export default __webpack_public_path__ + "static/media/hero-image.ed34417c.png";